/**
 * Create
 * @param state
 */

export const mapStateToProps = (state) => {
  return {
    // user
    loggedUser: state.user.loggedUser,
    selectedMenu: state.user.selectedMenu,
    errorMessage: state.user.errorMessage,
    successMessage: state.user.successMessage,
    technologies: state.user.technologies,
    // meeting
    meetings: state.meeting.meetings,
    meeting: state.meeting.meeting,
    invitedIn: state.meeting.invitedIn,
    rooms: state.meeting.rooms,
    resources: state.meeting.resources,
    meetingList: state.meeting.meetingList,
    // minutes
    minutesTemplate: state.meeting.minutesTemplate,
    minutesDetails: state.meeting.minutesDetails,
    // project
    projects: state.project.projects,
    // qualification
    qualifications: state.qualification.qualifications,
    qualification: state.qualification.qualification,
    menus:state.user.menus,
    userPermissions:state.user.userPermissions,
    structures:state.user.structures,
    systemSettings:state.user.systemSettings,
    wholeStructure: state.user.wholeStructure,


  };
};
